import { freeTrialProviderRequestUrls } from 'utils/apiUrls';
import { HttpType, IFetchParams } from 'utils/http';
import { AssociateFreeTrialPracticePayload, CreateFreeTrialProviderPayload, CreateFreeTrialProviderResponse, FreeTrialOnboardingStatusResponse, FreeTrialPatientStatsResponse, FreeTrialPracticesDropdownResponse, InviteFreeTrialProvidersPayload, PaymentCheckoutSessionPayload, PaymentCheckoutSessionResponse, VerifyOtpFreeTrialPayload, VerifyOtpFreeTrialResponse } from 'pages/Dashboard/types/freeTrial.types';

export const createFreeTrialProvider = (method: HttpType['post'], payload: CreateFreeTrialProviderPayload): Promise<CreateFreeTrialProviderResponse> => method(freeTrialProviderRequestUrls.createFreeTrialProvider.apiUrl(), payload);

export const sendFreeTrialOtp = (method: HttpType['post'], providerId: string) => method(freeTrialProviderRequestUrls.sendOtp.apiUrl(), { providerId });

export const verifyFreeTrialOtp = (method: HttpType['post'], payload: VerifyOtpFreeTrialPayload): Promise<VerifyOtpFreeTrialResponse> => method(freeTrialProviderRequestUrls.verifyOtp.apiUrl(), payload);

export const changeFreeTrialPassword = (method: HttpType['post'], password: string, token?: string) => method(freeTrialProviderRequestUrls.changePassword.apiUrl(), { password }, token ? { headers: { Authorization: `Bearer ${token}` } } as IFetchParams : undefined);

export const fetchPracticesDropdown = (
  method: HttpType['get'],
  queryParams?: string,
): Promise<FreeTrialPracticesDropdownResponse> => {
  const url = freeTrialProviderRequestUrls.practicesDropdown.apiUrl(queryParams);
  return method(
    url.list,
  );
};

export const associateFreeTrialPractice = (method: HttpType['post'], payload: AssociateFreeTrialPracticePayload): Promise<CreateFreeTrialProviderResponse> => method(freeTrialProviderRequestUrls.associatePractice.apiUrl(), payload);

export const inviteFreeTrialProviders = (method: HttpType['post'], payload: InviteFreeTrialProvidersPayload, token?: string) => method(freeTrialProviderRequestUrls.inviteProviders.apiUrl(), payload, token ? { headers: { Authorization: `Bearer ${token}` } } as IFetchParams : undefined);

export const checkoutSession = (method: HttpType['post'], payload: PaymentCheckoutSessionPayload, token?: string): Promise<PaymentCheckoutSessionResponse> => method(freeTrialProviderRequestUrls.checkoutSession.apiUrl(), payload, token ? { headers: { Authorization: `Bearer ${token}` } } as IFetchParams : undefined);

export const getFreeTrialOnboardingStatus = (
  method: HttpType['get'],
  token?: string,
): Promise<FreeTrialOnboardingStatusResponse> => {
  const url = freeTrialProviderRequestUrls.onboardingStatus.apiUrl();
  return method(
    url,
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
  );
};

export const updateProviderGoal = (
  method: HttpType['put'],
  providerId: string,
  goal: string,
) => {
  const url = freeTrialProviderRequestUrls.updateGoal.apiUrl(providerId);
  return method(url, { goal });
};

export const getPatientStats = (
  method: HttpType['get'],
  providerId: string,
): Promise<FreeTrialPatientStatsResponse> => {
  const url = freeTrialProviderRequestUrls.patientStats.apiUrl(providerId);
  return method(url);
};
